import ready, { HTML } from './utils';
import Alpine from 'alpinejs';
import initSticky from './components/stickyScroll';
import initSlider from './components/slider';
import scrollIntoViewWithOffset from './components/scrollIntoViewWithOffset.js';
import initAccessibility from './components/userway';
import Gmap from './components/map.es6';
import './components/animations';
import './components/filter';
import './components/hero-slider';
import './components/slider';
import './components/state';
import './plugins/fitvids';
import Cookies from './components/cookie';
window.Cookies = Cookies;

Alpine.start();

ready(() => {
  HTML.classList.add('is-loaded');
  initSticky();
  initSlider();

  fitVids({
    customSelector: '.video-player, .text-wrap'
  });

});

window.initMap = () => {
  const map = new Gmap('.acf-map');
  map.setup();
}